import {createStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import {RootState} from '../../interfaces'
import {uiEventLoggerMiddleware, uiEventActions, maintenanceHandlerMiddleware} from '../../store/result/middlewares'

import createRootReducer from './reducer'
import ResultSentryEnhancer from './sentryEnhancer'

/** 주문결과 store */
const store = createStore<RootState>({
    rootReducerCreator: createRootReducer,
    middlewares: [maintenanceHandlerMiddleware, uiEventLoggerMiddleware, browserEventEmitter],
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [...uiEventActions],
        },
    },
    sentryEnhancerOptions: ResultSentryEnhancer,
})

export default store
